// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".BwJGjCNkjrYARvAlYnAy{width:100%}.nOmirjJAb86Fg2_9BnSQ{width:100%;height:100%;margin:auto;display:flex}.nOmirjJAb86Fg2_9BnSQ.Cq3niM4wl5ekEdQFFbwv>img{align-self:flex-start}.nOmirjJAb86Fg2_9BnSQ.Ryyuhp2jjVoqyOBAXGHh>img{align-self:center}.nOmirjJAb86Fg2_9BnSQ.lThGsOGBmiXEeofUKt5i>img{align-self:flex-end}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"creative": "BwJGjCNkjrYARvAlYnAy",
	"creativeContainer": "nOmirjJAb86Fg2_9BnSQ",
	"alignTop": "Cq3niM4wl5ekEdQFFbwv",
	"alignCenter": "Ryyuhp2jjVoqyOBAXGHh",
	"alignBottom": "lThGsOGBmiXEeofUKt5i"
};
export default ___CSS_LOADER_EXPORT___;
